module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "",
      "columns": 12
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.announcementVariation.sku),
      expression: "announcementVariation.sku"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.migration.done
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.announcementVariation, "sku", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('no.migration.label')))]), _vm._v(" "), _vm._l((_vm.productVariations), function(productVariation) {
    return _c('option', {
      key: productVariation,
      domProps: {
        "value": productVariation.sku
      }
    }, [_vm._v("\n        " + _vm._s(_vm.productVariationName(productVariation)) + "\n      ")])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e168b88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/migration/WithoutVariation.vue
// module id = 3148
// module chunks = 0